export enum ReverificationStatusEnum {
  REQUESTED = 'REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  LAPSED = 'LAPSED',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED',
}
